import { useState } from 'react';
import { Button } from '../../../components/form/button';
import Icon from '../../../components/icons/icon';
import { Spinner } from '../../../components/spinner/spinner';
import { TextArea } from '../../../components/textarea/textarea';
import { Typography } from '../../../components/typography/typography';
import { toast } from '../../../util/toasts';
import { OrderSection } from '../order-section/order-section';

export const DefaultInvoiceFreeText = ({
  defaultInvoiceFreeText,
  updateDefaultInvoiceFreeText,
  isRentalDisclaimer = false,
}: {
  defaultInvoiceFreeText?: string;
  updateDefaultInvoiceFreeText: (value: string) => Promise<void>;
  isRentalDisclaimer?: boolean;
}) => {
  const [isEditing, setIsEditing] = useState<boolean>(false);
  const [isLoading, setLoading] = useState<boolean>(false);
  const [value, setValue] = useState<string>(defaultInvoiceFreeText || '');

  const submit = async () => {
    if (isLoading) return;

    setLoading(true);

    try {
      await updateDefaultInvoiceFreeText(value);
      toast(`${isRentalDisclaimer ? 'Rental disclaimer' : 'Default invoice free text'} updated sucessfully.`);
      setIsEditing(false);
    } catch (ex: any) {
      toast(ex.message.msg || ex.message, 'error');
    } finally {
      setLoading(false);
    }
  };

  return (
    <OrderSection
      header={
        <div className="flex items-center justify-between">
          <Typography type="text-md" weight="medium" className="text-grey-800">
            {isRentalDisclaimer ? 'Rental Disclaimer' : 'Default Invoice Free Text'}
          </Typography>

          {defaultInvoiceFreeText && defaultInvoiceFreeText.length > 0 && (
            <Button
              className="button-tertiary circle !p-0"
              onClick={() => {
                setIsEditing(isEditing ? false : true);
              }}
            >
              <Icon icon={isEditing ? 'Close' : 'Edit'} stroke="var(--grey-400)" />
            </Button>
          )}
        </div>
      }
    >
      <div className="flex flex-col gap-[8px] pt-[8px]">
        {defaultInvoiceFreeText && defaultInvoiceFreeText.length > 0 && !isEditing ? (
          <Typography type="text-sm" className="text-grey-800 whitespace-pre-line">
            {defaultInvoiceFreeText}
          </Typography>
        ) : (
          <TextArea
            className="w-full h-full resize-none bg-grey-50 text-sm"
            placeholder={
              isRentalDisclaimer
                ? 'Add text above signature field on the contract'
                : 'Add text to contract/invoices under store details'
            }
            value={value}
            onChange={(e) => setValue(e.target.value)}
            maxLength={isRentalDisclaimer ? undefined : 85}
          />
        )}

        {isLoading ? (
          <Spinner />
        ) : (
          (defaultInvoiceFreeText ?? '') != value && (
            <div className="button-group" onClick={submit}>
              <Button className="button-secondary">Update</Button>
            </div>
          )
        )}
      </div>
    </OrderSection>
  );
};
